export default [{
    path: '/indicesCOGE',
    component: () => import('@/views/Index'),
    children: [
        {
            name: 'Índice COGE Histórico',
            path: 'historico',
            component: () => import('@/views/indicesCOGE/Historico.vue'),
            meta: {
                requiresAuth: true,
                admin: true,
                breadcrumb: [
                    { name: 'Dados', path: '/dados' },
                    { name: 'Indices COGE' }
                ]
            }
        },
        {
            name: 'Índice COGE Adicionar',
            path: 'edit',
            component: () => import('@/views/indicesCOGE/Edit.vue'),
            meta: {
                requiresAuth: true,
                admin: true,
                breadcrumb: [
                    { name: 'Dados', path: '/dados' },
                    { name: 'Indices COGE', path: '/indicesCOGE/historico' },
                    { name: 'Adicionar' }
                ]
            }
        },
        {
            name: 'Índice COGE Visualizar',
            path: 'visualizar/:data_registro',
            component: () => import('@/views/indicesCOGE/Visualizar.vue'),
            meta: {
                requiresAuth: true,
                admin: true,
                breadcrumb: [
                    { name: 'Dados', path: '/dados', },
                    { name: 'Indices COGE', path: '/indicesCOGE/historico' },
                    { name: 'Visualizar' },
                ]
            }
        }
    ]
}]